<template>
  <v-container>
    <table width="100%" style="border: 10px blue solid;">
      <tbody>
        <tr>
          <td colspan="2" align="center" bgcolor="#CCCCFF">
            <b>ISO/TR 12295</b>
          </td>
        </tr>
        <tr>
          <td colspan="2" align="center" width="1500px">
            <b>
              <img src="../../../assets/isotr.png" width="100%" />
            </b>
          </td>
        </tr>
        <tr>
          <td bgcolor="#CCFADB">
            <b>1. Manipulación manual de cargas ISO/TR 11228-1</b>
          </td>
          <td bgcolor="#CCFADB">
            <v-card-actions>
                <v-btn color="orange" @click="openDialogForm(1,'Manipulación manual de cargas ISO/TR 11228-1')" text>
                    Ir a ...
                </v-btn>                
            </v-card-actions>
          </td>
        </tr>
        <tr>
          <td bgcolor="#CCFADB">
            <b>2. Empuje y tracción de cargas ISO/TR 11228-2</b>
          </td>
          <td bgcolor="#CCFADB">
            <v-card-actions>
                <v-btn color="orange" @click="openDialogForm(2,'Empuje y tracción de cargas ISO/TR 11228-2')" text>
                    Ir a ...
                </v-btn>                
            </v-card-actions>
          </td>
        </tr>
        <tr>
          <td bgcolor="#CCFADB">
            <b>3. Movimientos repetitivos ISO/TR 11228-3</b>
          </td>
          <td bgcolor="#CCFADB">
            <v-card-actions>
                <v-btn color="orange" @click="openDialogForm(3,'Movimientos repetitivos ISO/TR 11228-3')" text>
                    Ir a ...
                </v-btn>                
            </v-card-actions>
          </td>
        </tr>
        <tr>
          <td bgcolor="#CCFADB">
            <b>4. Posturas y movimientos ISO/TR 11226</b>
          </td>
          <td bgcolor="#CCFADB">
            <v-card-actions>
                <v-btn color="orange" @click="openDialogForm(4,'Posturas y movimientos ISO/TR 11226')" text>
                    Ir a ...
                </v-btn>                
            </v-card-actions>
          </td>
        </tr>
      </tbody>
    </table>

    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-card-text overflow-y height="100%">
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="closeDialogForm">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{this.formName}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>          
          <isotr112281 v-if="formNumber==1"></isotr112281>
          <isotr112282 v-if="formNumber==2"></isotr112282>
          <isotr112283 v-if="formNumber==3"></isotr112283>
          <isotr11226 v-if="formNumber==4"></isotr11226>          
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Isotr112281 from "./Isotr11228-1";
import Isotr112282 from "./Isotr11228-2";
import Isotr112283 from "./Isotr11228-3";
import Isotr11226 from "./Isotr11226";

export default {
  components: {
    Isotr112281,
    Isotr112282,
    Isotr112283,
    Isotr11226
  },
  props: ["company"],
  data() {
    return {
      dialogForm: false,
      formNumber: "",
      formName: "",
      carouselValue: 1,
      monitoreoAuditivoCs: null,
      listMonitoreoAuditivoCs: [],
      radioGroup: 1,
      search: "",
      valid: false,
      requiredField: [v => !!v || "Es requerido"],
      dialog: false
    };
  },
  methods: {
    openDialogForm(number, name) {
      this.dialogForm = true;
      this.formNumber = number;
      this.formName = name;
    },
    changeCarouselForward() {
      if (this.carouselValue != 7) {
        this.carouselValue = this.carouselValue + 1;
      } else {
        this.carouselValue = 1;
      }
    },
    changeCarouselBackward() {
      if (this.carouselValue != 1) {
        this.carouselValue = this.carouselValue - 1;
      } else {
        this.carouselValue = 7;
      }
    },
    closeDialogForm() {
      this.dialogForm = false;
      this.formNumber = "";
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Isotr12295.vue